"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheGet = cacheGet;
exports.cacheClear = cacheClear;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var cache = {};

function cacheGet(_x, _x2) {
  return _cacheGet.apply(this, arguments);
}

function _cacheGet() {
  _cacheGet = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(key, fallback) {
    var value;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(cache[key] != null)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", cache[key]);

          case 2:
            _context.next = 4;
            return fallback();

          case 4:
            value = _context.sent;
            cache[key] = value;
            return _context.abrupt("return", value);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _cacheGet.apply(this, arguments);
}

function cacheClear(key) {
  delete cache[key];
}